/* eslint-disable react-hooks/exhaustive-deps */
import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";

const TwitterCard = ({mission, setAllLRCMissionsDone, onClose}) => {
  const [likeClicked, setLikeClicked] = useState(false);
  const [retweetClicked, setRetweetClicked] = useState(false);
  const [commentClicked, setCommentClicked] = useState(false);

  useEffect(() => {
    if(
      ((mission?.link_comment_tweet && commentClicked) || !mission?.link_comment_tweet)
      && ((mission?.link_retweet_tweet && retweetClicked) || !mission?.link_retweet_tweet)
      && ((mission?.link_like_tweet && likeClicked) || !mission?.link_like_tweet)
    ) {
      setAllLRCMissionsDone(true);
    } else {
      setAllLRCMissionsDone(false);
    }
  }, [likeClicked, retweetClicked, commentClicked]);

  return (
    <>
      <div className="font-sans min-w-96 rounded-md px-4">
        <div
          className={`flex justify-end`}
        >
          <button onClick={onClose} className="text-[22px] !ring-0 !ring-transparent !ring-offset-0 outline-none hover:outline-none !shadow-none">
            <Icon icon="heroicons-outline:x" />
          </button>
        </div>
        <div className="flex items-center justify-between mb-3">
          {/*
          <img src="https://pbs.twimg.com/profile_images/1488434260860182529/uCD5L1hQ_400x400.jpg" className="h-12 w-12 rounded-full mr-4" />
          */}
            <div className="flex flex-col">
              <span className="font-bold text-white">{mission?.lrc_screen_name}</span>
              <span className="text-metaxseed-text-gray">@{mission?.lrc_user_name}</span>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="1.5rem" height="1.5rem" viewBox="0 0 16 16">
              <path fill="#ffffff" d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07l-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
            </svg>
        </div>
        <div className="my-3 leading-normal text-lg text-white" dangerouslySetInnerHTML={{__html: mission?.lrc_tweet_text}}>
          
        </div>
        <div className="text-metaxseed-text-gray mb-6 text-sm">
          {(new Date(mission?.lrc_date_time.seconds * 1000)).toLocaleString()}
        </div>
        <div className="flex text-metaxseed-text-gray justify-around items-center">
              {mission?.link_comment_tweet &&
            <a className={(commentClicked ? "bg-metaxseed-content-gray text-metaxseed-dark-gray" : " hover:bg-blue-400  text-white") + " cursor-pointer flex items-center  rounded-md mr-2 px-4 py-2 outline-none hover:outline-none !ring-transparent !ring-0 !ring-offset-0 !shadow-none"}  onClick={() => { window.open(mission?.link_comment_tweet, "_blank"); setCommentClicked(true)} }>
                <svg className="mr-2" width="24" height="24" viewBox="0 0 24 24">
                    <path className="fill-current"
                        d="M14.046 2.242l-4.148-.01h-.002c-4.374 0-7.8 3.427-7.8 7.802 0 4.098 3.186 7.206 7.465 7.37v3.828c0 .108.045.286.12.403.143.225.385.347.633.347.138 0 .277-.038.402-.118.264-.168 6.473-4.14 8.088-5.506 1.902-1.61 3.04-3.97 3.043-6.312v-.017c-.006-4.368-3.43-7.788-7.8-7.79zm3.787 12.972c-1.134.96-4.862 3.405-6.772 4.643V16.67c0-.414-.334-.75-.75-.75h-.395c-3.66 0-6.318-2.476-6.318-5.886 0-3.534 2.768-6.302 6.3-6.302l4.147.01h.002c3.532 0 6.3 2.766 6.302 6.296-.003 1.91-.942 3.844-2.514 5.176z">
                    </path>
                </svg>
                
                <span>
                  {commentClicked ? "Commented" : "Comment"}
                </span>
              </a>
              }
              {mission?.link_retweet_tweet &&

            <a className={(retweetClicked ? "bg-metaxseed-content-gray text-metaxseed-dark-gray" : " hover:bg-green-500  text-white") + " cursor-pointer flex items-center mr-2 rounded-md px-4 py-2 outline-none hover:outline-none !ring-transparent !ring-0 !ring-offset-0 !shadow-none"}  onClick={() => { window.open(mission?.link_retweet_tweet, "_blank"); setRetweetClicked(true)} }>
              
              <svg className="mr-2" width="24" height="24" viewBox="0 0 24 24">
                    <path className="fill-current"
                        d="M23.77 15.67c-.292-.293-.767-.293-1.06 0l-2.22 2.22V7.65c0-2.068-1.683-3.75-3.75-3.75h-5.85c-.414 0-.75.336-.75.75s.336.75.75.75h5.85c1.24 0 2.25 1.01 2.25 2.25v10.24l-2.22-2.22c-.293-.293-.768-.293-1.06 0s-.294.768 0 1.06l3.5 3.5c.145.147.337.22.53.22s.383-.072.53-.22l3.5-3.5c.294-.292.294-.767 0-1.06zm-10.66 3.28H7.26c-1.24 0-2.25-1.01-2.25-2.25V6.46l2.22 2.22c.148.147.34.22.532.22s.384-.073.53-.22c.293-.293.293-.768 0-1.06l-3.5-3.5c-.293-.294-.768-.294-1.06 0l-3.5 3.5c-.294.292-.294.767 0 1.06s.767.293 1.06 0l2.22-2.22V16.7c0 2.068 1.683 3.75 3.75 3.75h5.85c.414 0 .75-.336.75-.75s-.337-.75-.75-.75z">
                    </path>
                </svg><span>
                  {retweetClicked ? "Retweeted" : "Retweet"}
                </span>
                </a>
              }
              {mission?.link_like_tweet &&

            <a className={(likeClicked ? "bg-metaxseed-content-gray text-metaxseed-dark-gray" : "  hover:bg-red-500  text-white") + " cursor-pointer flex items-center mr-2 rounded-md px-4 py-2 outline-none hover:outline-none !ring-transparent !ring-0 !ring-offset-0 !shadow-none"} onClick={() => { window.open(mission?.link_like_tweet, "_blank"); setLikeClicked(true)} }>
              <svg className="mr-2" width="24" height="24" viewBox="0 0 24 24">
                    <path className="fill-current"
                        d="M12 21.638h-.014C9.403 21.59 1.95 14.856 1.95 8.478c0-3.064 2.525-5.754 5.403-5.754 2.29 0 3.83 1.58 4.646 2.73.813-1.148 2.353-2.73 4.644-2.73 2.88 0 5.404 2.69 5.404 5.755 0 6.375-7.454 13.11-10.037 13.156H12zM7.354 4.225c-2.08 0-3.903 1.988-3.903 4.255 0 5.74 7.035 11.596 8.55 11.658 1.52-.062 8.55-5.917 8.55-11.658 0-2.267-1.822-4.255-3.902-4.255-2.528 0-3.94 2.936-3.952 2.965-.23.562-1.156.562-1.387 0-.015-.03-1.426-2.965-3.955-2.965z">
                    </path>
                </svg><span>
                  {likeClicked ? "Liked" : "Like"}
                </span>
                </a>
}
        </div>
    </div>
    </>
  );
};

export default TwitterCard;
